module.exports = __webpack_public_path__ + "img/9788958202646.873a06ff.jpg";